import { Box, Flex, Text } from "@chakra-ui/react";
import UserAvatar from "components/elements/UserAvatar";
import { Link, useParams } from "react-router-dom";

const ConversationsList = ({ conversations }: { conversations: any[] }) => {
  const { id } = useParams();

  return conversations.length > 0 ? (
    <Flex direction="column" gap={4}>
      {conversations.map((conversation: any) => (
        <Link key={conversation.id} to={`/messages/${conversation.id}`}>
          <Box
            bg={id === conversation.id ? "gray.50" : "white"}
            borderRadius="12px"
            p={4}
            cursor="pointer"
            filter={
              id === conversation.id
                ? "none"
                : "drop-shadow(0px 4px 4px rgba(204, 204, 204, 0.25)) drop-shadow(0px 0px 15px rgba(198, 198, 198, 0.25))"
            }
            _hover={{
              bg: "gray.100",
            }}
          >
            <Flex alignItems="center">
              <Flex gap={4} alignItems="center">
                <UserAvatar size="51px" user={conversation.participant} />
                <Flex direction="column">
                  <Text fontWeight="500" fontSize="15px" color="primary">
                    {conversation.participant.first_name} {conversation.participant.last_name}
                  </Text>
                  <Text color="gray.500" fontWeight="500" fontSize="12px">
                    {conversation.participant.tagline}
                  </Text>
                </Flex>
              </Flex>
            </Flex>
          </Box>
        </Link>
      ))}
    </Flex>
  ) : (
    <Text color="#515355" fontSize="14px">
      No conversations yet.
    </Text>
  );
};

export default ConversationsList;
